import React, { useState } from 'react'

import Translator from 'bazinga-translator'
import useSearch from 'components/GamesNavBar/hooks/useSearch'

import { Icon } from './Icon'
import { GAMES_SEARCH_FIELD_NAME } from './constants'
import { Box, StyledInput } from './styles'

export function Search() {
  const { search, setSearch } = useSearch()
  const [isInputFocused, setIsInputFocused] = useState(false)
  const isActive = search?.length > 0 || isInputFocused

  return (
    <Box isActive={isActive}>
      <Icon
        isActive={isActive}
        clearSearch={() => setSearch('')}
      />
      <StyledInput
        id={GAMES_SEARCH_FIELD_NAME}
        name={GAMES_SEARCH_FIELD_NAME}
        data-testid={GAMES_SEARCH_FIELD_NAME}
        onFocus={() => setIsInputFocused(true)}
        onBlur={() => setIsInputFocused(false)}
        autoFocus={search?.length > 0}
        onChange={({ currentTarget: { value } }) => setSearch(value)}
        placeholder={Translator.trans('Search')}
        value={search}
      />
    </Box>
  )
}
